export default __webpack_public_path__ + "static/media/unlock-icon.e60fac02.svg";